// Grid Toggle
const gridButton = document.querySelector('#grid-toggle')
const grid = document.querySelector('#grid-overlay')

if (gridButton && grid) {
  gridButton.addEventListener('click', () => {
    if (grid.classList.contains('is-hidden')) {
      grid.classList.remove('is-hidden')
    } else {
      grid.classList.add('is-hidden')
    }
  })
}
